export const mapDatasource = (data)=>{
    if (!data) {
        return [];
    }
    return data?.map((item) => {
        return {
            id : item.id,
            weighingStationName : item.weighingStationName,
            weighingStationCode : item.weighingStationCode,
            address : item.address,
            status : item.status,
        };
    });
}
